import uuidV4 from 'lib/string/uuidV4Utils'

export function generateMerchandiseCartItem(
  offer: App.MerchandiseOffer,
  variant: App.MerchandiseOfferVariant,
): App.Checkout.MerchandiseItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: 'merchandise',
    offerId: offer.id,
    variantId: variant.id,
  }
}
